import React from "react";
import "./MianBuilderBrands.css";
import logo from "../../../assets/MianBuilderLogo.png";
import image from "../../../assets/mianbuilderbrands.jpg";

const MianBuilderBrands = () => {
  return (
    <div className="Mian-Builder-Brands-1">
      <img
        src={image}
        alt="Mian Builder Brands"
        className="Mian-Builder-Brands-Custom-image"
      />
      <a href="http://mianbuilder.com" target="_blank" rel="noopener noreferrer">
        <img
          src={logo}
          alt="Mian Builder Logo"
          className="Mian-Builder-Brands-Custom-logo"
        />
      </a>
    </div>
  );
};

export default MianBuilderBrands;
